import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingHorizontalXS,
    },
});
